import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { ROLES } from "../config/constants";
import AdminWalk from "./Admin/Walk";
import PetOwnerWalk from "./Pet Owner/Walk";

const Walk = () => {
  const { user, roles, permission,updateContext } = useContext(UserContext);
  if (roles.includes(ROLES.ADMIN)) {
    return <AdminWalk user={user} roles={roles} />;
  } else if (roles.includes(ROLES.USER)) {
    return <PetOwnerWalk user={user} userRoles={roles} userPermission={permission} updateContext={updateContext} />;
  } else {
    return <></>;
  }
};

export default Walk;
